import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/Navbar.css"; 

const MyNavbar = () => {
  const [activeLink, setActiveLink] = useState("/");

  return (
    <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="py-2 mobilenav  ">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img 
            src="/logo1.png" 
            alt="Bhanot International Logo" 
            height="120"
            style={{paddingLeft:"120px",position: "absolute", paddingTop:"20px"}}
            className="logo_header"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {[
              { name: "Home", path: "/" },
              { name: "About Us", path: "/about" },
              { name: "Certifications", path: "/certifications" },
              { name: "Services", path: "/services" },
              { name: "Team", path: "/team" },
              { name: "Workplace", path: "/workplace" }, 
              { name: "ICE", path: "/ice" },
              { name: "ICE Registration", path: "/ice-registration" },
              { name: "Careers", path: "/careers" },
              { name: "Contact Us", path: "/contact" },
              { name: "Marketplace", path: "/marketplace" }
            ].map((link) => (
              <Nav.Link
                key={link.path}
                as={Link}
                to={link.path}
                className={`text-light ${activeLink === link.path ? "active" : ""}`}
                onClick={() => setActiveLink(link.path)}
                style={activeLink === link.path ? { borderBottom: "2px solid yellow" } : {}}
              >
                {link.name}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MyNavbar;

// import React, { useState } from "react";
// import { Navbar, Nav, Container } from "react-bootstrap";

// const MyNavbar = () => {
//   const [activeLink, setActiveLink] = useState("#home");

//   return (
//   <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="py-2">
//     <Container>
//       <Navbar.Brand href="/" className="d-flex align-items-center">
//         <img 
//           src="/logo1.png" 
//           alt="Bhanot International Logo" 
//           style={{ maxHeight: "80px", width: "auto", padding: "5px" }} 
//         />
//       </Navbar.Brand>

//       <Navbar.Toggle aria-controls="basic-navbar-nav" />
//       <Navbar.Collapse id="basic-navbar-nav">
//         <Nav className="ms-auto">
//           {[
//             { name: "Home", href: "#home" },
//             { name: "About Us", href: "#about" },
//             { name: "Certifications", href: "#certifications" },
//             { name: "Services", href: "#services" },
//             { name: "Security", href: "#security" },
//             { name: "ICE", href: "#ice" },
//             { name: "ICE Registration", href: "#ice-registration" },
//             { name: "Careers", href: "#careers" },
//             { name: "Contact Us", href: "#contact" },
//             { name: "Marketplace", href: "#marketplace" }
//           ].map((link) => (
//             <Nav.Link
//               key={link.href}
//               href={link.href}
//               className={`text-light ${activeLink === link.href ? "active" : ""}`}
//               onClick={() => setActiveLink(link.href)}
//               style={activeLink === link.href ? { borderBottom: "2px solid yellow" } : {}}
//             >
//               {link.name}
//             </Nav.Link>
//           ))}
//         </Nav>
//       </Navbar.Collapse>
//     </Container>
//   </Navbar>


//   );
// };

// export default MyNavbar;